export const LINE_TYPE = {
  LANDLINE: 'landlineOffer',
  MAIN_MOBILE: 'mainMobileLineOffer',
  EXTRA_LINE: 'extraMobileLinesOffers',
}
